export default __webpack_public_path__ + "static/media/a001-whatsapp-03.d2dead66.png";